import { SharpLoaderImage } from '@web/utils/sharp-loader';

import DarkImage1 from './dark-photo-01.png';
import DarkImage2 from './dark-photo-02.png';
import DarkImage3 from './dark-photo-03.png';
import DarkImage4 from './dark-photo-04.png';
import DarkImage5 from './dark-photo-05.png';
import DarkImage6 from './dark-photo-06.png';
import DarkImage7 from './dark-photo-07.png';
import DarkImage8 from './dark-photo-08.png';
import DarkImage9 from './dark-photo-09.png';
import DarkImage10 from './dark-photo-10.png';
import DarkImage11 from './dark-photo-11.png';
import DarkImage12 from './dark-photo-12.png';
import DarkImage13 from './dark-photo-13.png';
import DarkImage14 from './dark-photo-14.png';
import DarkImage15 from './dark-photo-15.png';
import DarkImage16 from './dark-photo-16.png';
import DarkImage17 from './dark-photo-17.png';
import DarkImage18 from './dark-photo-18.png';
import DarkImage19 from './dark-photo-19.png';
import DarkImage20 from './dark-photo-20.png';
import LightImage1 from './light-photo-01.png';
import LightImage2 from './light-photo-02.png';
import LightImage3 from './light-photo-03.png';
import LightImage4 from './light-photo-04.png';
import LightImage5 from './light-photo-05.png';
import LightImage6 from './light-photo-06.png';
import LightImage7 from './light-photo-07.png';
import LightImage8 from './light-photo-08.png';
import LightImage9 from './light-photo-09.png';
import LightImage10 from './light-photo-10.png';
import LightImage11 from './light-photo-11.png';
import LightImage12 from './light-photo-12.png';
import LightImage13 from './light-photo-13.png';
import LightImage14 from './light-photo-14.png';
import LightImage15 from './light-photo-15.png';
import LightImage16 from './light-photo-16.png';
import LightImage17 from './light-photo-17.png';
import LightImage18 from './light-photo-18.png';
import LightImage19 from './light-photo-19.png';
import LightImage20 from './light-photo-20.png';

export const DARK_IMAGES: readonly SharpLoaderImage[][] = [
  DarkImage1,
  DarkImage2,
  DarkImage3,
  DarkImage4,
  DarkImage5,
  DarkImage6,
  DarkImage7,
  DarkImage8,
  DarkImage9,
  DarkImage10,
  DarkImage11,
  DarkImage12,
  DarkImage13,
  DarkImage14,
  DarkImage15,
  DarkImage16,
  DarkImage17,
  DarkImage18,
  DarkImage19,
  DarkImage20,
];

export const LIGHT_IMAGES: readonly SharpLoaderImage[][] = [
  LightImage1,
  LightImage2,
  LightImage3,
  LightImage4,
  LightImage5,
  LightImage6,
  LightImage7,
  LightImage8,
  LightImage9,
  LightImage10,
  LightImage11,
  LightImage12,
  LightImage13,
  LightImage14,
  LightImage15,
  LightImage16,
  LightImage17,
  LightImage18,
  LightImage19,
  LightImage20,
];

export function getRandomImages(
  images: readonly SharpLoaderImage[][],
  count: number,
): readonly SharpLoaderImage[][] {
  const shuffled = [...images].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(count, images.length));
}
